import { h } from 'preact'; /** @jsx h */

import SupportUsForm from '../../forms/SupportUsForm';

import CTABlock from '../components/jantore/CTABlock/CTABlock';
import Content from '../components/jantore/Content/Content';
import FactsItem from '../components/jantore/FactsList/FactsItem/FactsItem';
import FactsList from '../components/jantore/FactsList/FactsList';
import Heading from '../components/jantore/Heading/Heading';
import Hero from '../components/jantore/Hero/Hero';
import Image from '../components/jantore/Image/Image';
import InlineCTA from '../components/jantore/InlineCTA/InlineCTA';
import Paragraph from '../components/jantore/Paragraph/Paragraph';
import ParallaxBanner from '../components/jantore/ParallaxBanner/ParallaxBanner';
import ParallaxContent from '../components/jantore/ParallaxBanner/ParallaxContent/ParallaxContent';
import Quote from '../components/jantore/Quote/Quote';
import Section from '../components/jantore/Section/Section';
import StickyCTA from '../components/jantore/StickyCTA/StickyCTA';

import '../styles/jantore/foerti-minutter-hlr.scss';

const renderFromDone = id => {
    if (window.location.hash === '#' + id) {
        const elemtentWithForm = document.querySelector('#' + id);

        elemtentWithForm.scrollIntoView();
    }
};

const FoertiMinutterHLR = () => {
    return (
        <div className="foerti-min-hlr">
            <Hero
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/03/40-min-hlr-hero-tall.jpg"
                alt="Jan Tore Persgård, sønnen Emil og svogeren Bjørn Gunnar Solnes står på luftambulansebasen i Trondheim."
            >
                <Heading type="h1" className="hero-title">
                    <span className="hero-title-section">
                        <span>40 minutter</span>
                    </span>
                    <span className="hero-title-section">med hjerte- og lungeredning</span>
                </Heading>
            </Hero>

            <Section top color="secondary">
                <StickyCTA
                    title="Bli støttemedlem"
                    text="Din støtte går til livreddende innovasjon og utvikling - slik som videoløsningen brukt i denne saken."
                    buttonText="Bli støttemedlem"
                    link="/bidrag_sm/?kamp=03_aa24_ph_sm&mtm_campaign=aa24&mtm_kwd=sm&mtm_source=pasienthistorie&mtm_content=ph&mtm_cid=01"
                    orientation="right"
                    icon
                />
                <Content width="small">
                    <Paragraph type="ingress" color="all-white">
                        Det siste Jan Tore Persgård (58) husker er at han parkerte bilen utenfor
                        redskapsboden til svogeren.
                    </Paragraph>
                    <Paragraph
                        type="byline"
                        text="Lasse Lønnebotn"
                        photo="Thomas T. Kleiven"
                        color="all-white"
                    />
                    <Paragraph type="normal" color="all-white">
                        Han husker ikke at han og sønnen byttet til vinterdekk på bilen. Han husker
                        ikke at han plutselig følte seg svimmel og ville sette seg ned, men falt om
                        på betonggulvet.
                    </Paragraph>
                    <Paragraph color="all-white">
                        Alt som skjedde i etterkant, denne oktoberdagen 2023 har han ikke noe minne
                        om, men dramaet som utspilte seg var avgjørende for hans videre skjebne.
                    </Paragraph>
                    <Paragraph color="all-white">
                        De neste 33 minuttene lå han på det kjølige gulvet, mens sønnen Emil (21) og
                        svogeren Bjørn Gunnar Solnes (51) byttet på å utføre hjertekompresjoner.
                        Emil hadde ringt 113, og fått en SMS om å koble til mobilkameraet slik at
                        operatøren kunne få se video av pasienten. Da var det ingen tvil:
                        Livreddende innsats måtte igangsettes.
                    </Paragraph>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-1"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/03/ribbeina-knakk-paa-jan-tore-full-scaled.jpg"
                alt="Jan Tore løfter på t-skjorten og viser frem ribbeina som ble knust under hjerte- og lungeredning."
                orientation="right"
                color="off-white"
                colorTop="secondary"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="right">
                    <Heading type="h3" color="all-white" weight="600" className="no-margin">
                        Ribbeina knakk
                    </Heading>
                    <Paragraph color="all-white" className="no-margin">
                        Jan Tore hadde fått hjertestans. Fjeset skiftet fra grønt til blått, hvitt
                        og rødt. Han hadde svak åndedrett i det ene øyeblikket og voldsomme
                        gurglelyder i det neste.
                    </Paragraph>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <Content width="small">
                    <Paragraph>
                        Underveis sa 113-operatøren at de måtte ta en kort pause så hun kunne
                        vurdere tilstanden, men da Emil og Bjørn Gunnar så at fjeset ble blekere,
                        fortsatte de med kompresjonene.
                    </Paragraph>
                    <Paragraph type="background" color="secondary">
                        De byttet på, og den som ikke utførte kompresjoner holdt Jan Tores hode.
                    </Paragraph>
                </Content>

                <Content width="small" type="image-float-right">
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/03/jan-tore-paa-besok-paa-base.jpg"
                        alt="Jan Tore står sammen med sønnen, svogeren og luftambulanse lege foran legehelikopteret på basen i Trondheim."
                        caption="Her står Jan Tore sammen med sønn, svoger og luftambulanse lege."
                    />
                    <div>
                        <Paragraph>
                            Bjørn Gunnar komprimerte stående med én hånd, fordi knærne hans ikke
                            tålte det harde gulvet. Emil satt ved siden av og brukte begge sine
                            sterke håndballarmer mot farens bryst. Midt i et rot av oljekanner,
                            bildekk og verktøy, trykte de så hardt at ribbeina knakk.
                        </Paragraph>
                        <Paragraph>
                            De ble slitne og spurte 113-operatøren igjen og igjen om når ambulansen
                            kom. Marthe, Jan Tores kone, kom etter omtrent 20 minutter og hjalp til,
                            men hun slet med å trykke hardt nok. Dermed måtte Emil og Bjørn Gunnar
                            fortsette kompresjonene, selv om de var utslitt.
                        </Paragraph>
                        <Paragraph>
                            20 minutter ble til 25 og 30. Sekunder føltes som minutter, minutter som
                            timer. Var innsatsen nytteløs? Var Jan Tore allerede død?
                        </Paragraph>
                    </div>
                </Content>

                <Content width="small">
                    <Heading>Reddet av sønnen og svogeren</Heading>
                    <Paragraph>
                        Tre måneder senere: En blanding av alvor og munterhet preger de fire
                        personene som er samlet på luftambulansens base i Trondheim. Foran
                        legehelikopteret, i rød luftambulansedress, står anestesilege Steinar
                        Einvik, og i en hestesko rundt ham står Jan Tore, Bjørn Gunnar og Emil.
                        Pasient, sønn og svoger.
                    </Paragraph>
                    <InlineCTA
                        buttonText="<b>Bli støttemedlem</b>"
                        link="/bidrag_sm/?kamp=03_aa24_ph_sm&mtm_campaign=aa24&mtm_kwd=sm&mtm_source=pasienthistorie&mtm_content=ph&mtm_cid=01"
                        color="primary"
                    />
                    <Paragraph type="background" color="secondary">
                        Lege Einvik var del av luftambulansens team som kom til Steinkjer den
                        oktoberdagen. Da takket han Emil og Bjørn Gunnar for «heroisk innsats» før
                        de tok Jan Tore med seg til St. Olavs Hospital i Trondheim.
                    </Paragraph>
                    <Paragraph>
                        Da Einvik og legehelikopteret – i tillegg til to ambulansebiler – ankom
                        etter 33 minutter, merket de at Jan Tores hjerterytme ikke var helt flat.
                        Den hadde en svak, men merkbar flimring.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Det betyr at hjertekompresjonene ga nok oksygen til hjertemusklene. Da er
                        det håp. Det var fantastisk å se, sier Einvik.
                    </Quote>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-2"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/03/heroisk-innsats-med-hlr-full.jpg"
                alt="Luftambulanse lege Steinar Einvik sitter ved døren på legehelikopteret og snakker med Jan Tore, Emil og Bjørn Gunnar."
                orientation="right"
                color="off-white"
                colorTop="off-white"
                colorBottom="secondary"
            >
                <ParallaxContent orientation="left">
                    <Heading type="h3" color="all-white" weight="600" className="no-margin">
                        «Heroisk innsats»
                    </Heading>
                    <Paragraph color="all-white" className="no-margin">
                        – Innsatsen deres viser at hjertekompresjoner virker – også når det går lang
                        tid. Det gjør at du får sirkulert blodet i kroppen, sier Einvik, Han syntes
                        hendelsen er så faglig spesiell at han skriver en egen rapport om tilfellet.
                    </Paragraph>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="secondary">
                <Content width="small" type="image-float-right">
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/03/jan-tore-tester-videosamtale-med-amk.jpg"
                        alt="Bilde viser hvordan det vil se ut når AMK har opprettet en videosamtale med Jan Tore."
                        caption="Bilde viser hvordan det vil se ut når man har opprettet en videosamtale med AMK."
                        captionColor="all-white"
                    />
                    <div>
                        <Heading color="all-white">Reddet etter 4 forsøk</Heading>
                        <Paragraph color="all-white">
                            Da ambulansepersonalet overtok for sønnen og svogeren, ga de Jan Tore
                            ett støt med hjertestarteren. Så enda ett og enda ett. Emil, Bjørn
                            Gunnar og Marthe sto skrekkslagne og så på. Var det likevel for sent?
                        </Paragraph>
                        <Paragraph type="background" color="all-white">
                            På det fjerde forsøket fikk de hjertet i gang.
                        </Paragraph>
                        <Quote animation="fade-up" color="all-white">
                            – At man holder på så lenge før den profesjonelle helsehjelpen kommer,
                            og at det likevel går bra … Det har jeg ikke vært borti før. Og jeg har
                            jobbet for luftambulansen siden 2008, sier Einvik.
                        </Quote>
                        <Paragraph color="all-white">
                            – Hva ville vært et vanlig utfall av dette?
                        </Paragraph>
                        <Quote animation="fade-up" color="all-white">
                            – Det er døden, det. Hvis man ikke gjør noe, kan det ved normal
                            kroppstemperatur utvikle seg skader på hjernen etter 4-5 minutter.
                            Derfor haster det å begynne med hjertekompresjoner.
                        </Quote>
                        <Paragraph color="all-white">Han ser mot Jan Tore.</Paragraph>
                        <Quote animation="fade-up" color="all-white">
                            – Emil og Bjørn Gunnar reddet livet ditt. I tillegg var bruken av video
                            fra 113-sentralen avgjørende, fordi det gjorde at dere fikk god
                            veiledning.
                        </Quote>
                    </div>
                </Content>

                <Content width="small">
                    <InlineCTA
                        type="text"
                        color="primary"
                        buttonText="<b>Bli støttemedlem</b> - Din støtte bidrar til å redde liv"
                        link="/bidrag_sm/?kamp=03_aa24_ph_sm&mtm_campaign=aa24&mtm_kwd=sm&mtm_source=pasienthistorie&mtm_content=ph&mtm_cid=01"
                    >
                        Mellom 70 og 80 prosent av alle som får plutselig og uventet hjertestans
                        dør. Med rask og riktig hjelp vil sjansen for å overleve øke. Med støtte fra
                        støttemedlemmer, givere og bedrifter finner Stiftelsen Norsk Luftambulanse
                        løsninger som redder liv.
                    </InlineCTA>
                    <Heading color="all-white">- Utrolig takknemlig</Heading>
                    <Paragraph color="all-white">
                        Hvordan reagerer du i krise? Får du panikk eller klarer du å holde hodet
                        kaldt? For Emil, som spiller håndball for 1.divisjonsklubben Charlottenlund,
                        var idrettserfaringen viktig:
                    </Paragraph>
                    <Quote animation="fade-up" color="all-white">
                        – Fra idretten har jeg lært å gå inn i sonen og bare gjøre jobben. Jeg måtte
                        beholde roen og ikke tenke, forteller Emil.
                    </Quote>
                    <Paragraph color="all-white">
                        Først senere samme kveld kom reaksjonen. Han var skjelven i kroppen og
                        oppdaget dype gnagsår i håndflatene. Bjørn Gunnar roser ham for innsatsen:
                    </Paragraph>
                    <Quote animation="fade-up" color="all-white">
                        – Emil tok ledelsen og viste enorm styrke. Han snakket hele tiden og sa:
                        «Det går bra, pappa, ambulansen kommer snart». Det var imponerende.
                    </Quote>
                    <Paragraph color="all-white">
                        – Var det til god hjelp for dere at 113-sentralen kunne se alt på video?
                    </Paragraph>
                    <Quote animation="fade-up" color="all-white">
                        – Ja, for da operatøren så ansiktet til pappa, sa hun med en gang: «Sett i
                        gang med hjerte- og lungeredning». I tillegg fikk vi instruksjoner hele
                        tiden. Det opplevde vi som trygt, forteller Emil.
                    </Quote>
                    <Paragraph color="all-white">
                        Jan Tore har lyttet intenst til samtalen. Nå har han behov for å si noe:
                    </Paragraph>
                    <Quote animation="fade-up" color="all-white">
                        – Det er spesielt å høre om seg selv på denne måten… Jeg er utrolig
                        takknemlig og imponert over den innsatsen dere gjorde.
                    </Quote>
                    <Paragraph color="all-white" type="link">
                        Ble utnevnt som vinner av Livredderprisen 2024 for sin innsats.
                    </Paragraph>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-3"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/03/jan-tore-med-fler-gaar-i-treningshallen-full.jpg"
                alt="Jan Tore, Emil og Bjørn Gunnar går i treningshallen."
                orientation="right"
                color="off-white"
                colorTop="secondary"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="right">
                    <Heading type="h3" color="all-white" weight="600" className="no-margin">
                        Fem tette blodårer
                    </Heading>
                    <Paragraph color="all-white" className="no-margin">
                        Da legehelikopteret tok med seg Jan Tore til sykehuset den oktoberdagen, sto
                        Emil og Bjørn Gunnar igjen i redskapsboden sammen med Marthe. Stillheten
                        senket seg mellom dem.
                    </Paragraph>
                    <Quote color="all-white" className="no-margin-bottom">
                        – Da var jeg usikker på om han ville overleve, sier Emil.
                    </Quote>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <Content width="small">
                    <Paragraph>
                        På St. Olavs hospital ble Jan Tore lagt i respirator. Snart ble fem tette
                        blodårer til hjertet åpnet opp og en hjertestarter satt inn.
                    </Paragraph>
                    <Paragraph>
                        Da familien kom til sykehuset dagen etter, var de spent på hva som møtte
                        dem. Levde han? Var han seg selv? Det første de la merke til, var at barten
                        han har hatt siden han var 16 år, var fjernet.
                    </Paragraph>
                    <Paragraph>Han smiler mot Emil og Jan Tore.</Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        Da Jan Tore våknet tok det ikke lang tid før han merket at barten var borte.
                        Da sa han: «Har de tatt barten? Jeg skal saksøke sykehuset!». Da skjønte vi
                        at han var seg selv igjen.
                    </Quote>
                    <InlineCTA
                        color="primary"
                        buttonText="<b>Bli støttemedlem</b> - Din støtte bidrar til å redde liv"
                        link="/bidrag_sm/?kamp=03_aa24_ph_sm&mtm_campaign=aa24&mtm_kwd=sm&mtm_source=pasienthistorie&mtm_content=ph&mtm_cid=01"
                    />
                    <Heading>– Et svært godt verktøy</Heading>
                    <Paragraph>
                        Med stiftelsens videoløsning kan norske legevakter og 113-sentraler se
                        pasientene i sanntid via innringerens mobilkamera. Det har trolig reddet
                        liv.
                    </Paragraph>
                    <Paragraph>
                        Første gang den ble tatt i bruk var i juni 2020. Da mest for å se på
                        småskader som utslett hos barn og enkle kutt, men siden har det å koble opp
                        video hos innringeren blitt svært nyttig for operatørene på 113-sentralen.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Det gjør det enklere for operatørene å veilede personene på skadeskadet.
                        Som for eksempel hvordan man kan sikre frie luftveier hos en skadet person,
                        og hvordan man skal plassere hendene på brystet for å utføre
                        hjertekompresjoner, sier Torill Sæternes, seksjonsleder hos AMK
                        Nord-Trøndelag.
                    </Quote>
                </Content>

                <Content width="small" type="image-float-right">
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/03/sms-fra-amk.jpg"
                        alt="En telefon med en SMS fra AMK med lenke til sikker videosamtale."
                        caption="SMS man mottar fra AMK med lenke der man oppretter en videosamtale"
                    />
                    <div>
                        <Paragraph>
                            AMK står for Akuttmedisinsk kommunikasjonssentral og er det samme som
                            113-sentralen.
                        </Paragraph>
                        <Paragraph>
                            – I hvilke andre skadesituasjoner er bruk av video nyttig?
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Vi har brukt video i situasjoner der det er melding om ulike skader
                            som er vanskelige å beskrive. Da kan vi ved hjelp av video få sett
                            omfanget av skadene bedre.
                        </Quote>
                        <Paragraph>
                            Før 2020 var det bare mulig å få hjelp fra 113-sentralen over telefon.
                            Nå kan en innringer få tilsendt en SMS med en lenke, som gir operatøren
                            direkte video av skadestedet.
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary" className="no-margin-bottom">
                            – Da må innringer trykke på lenken og sette på høyttaler, så kan
                            113-operatøren styre kameraet på telefonen og gi kyndig hjelp. Det er et
                            svært godt verktøy som gir oss øyne – ikke bare ører, sier Sæternes.
                        </Quote>
                    </div>
                </Content>

                <Content width="small">
                    <Paragraph>
                        Det er Stiftelsen Norsk Luftambulanse som har utviklet videoløsningen, og
                        det er støttemedlemmenes bidrag som har gjort dette mulig.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Det siste året ser vi en svært gledelig økning i antall oppkoblinger, som
                        kan tyde på at operatørene har omfavnet løsningen på en måte som gir direkte
                        fordeler for pasienten og situasjonene de håndterer.
                    </Quote>
                    <Paragraph>
                        – Kan man konkludere med at videoløsningen bidrar til å redde flere liv?
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Dette er det ikke forsket mye på, men ut ifra vår erfaring: Ja. Den redder
                        liv. Videoløsningen gjør at vi får bedre oversikt og dermed kan gi bedre
                        veiledning i livskritiske situasjoner.
                    </Quote>
                    <InlineCTA
                        type="image"
                        imgSrc="https://norskluftambulanse.no/wp-content/uploads/2024/03/jan-tore-med-folge-paa-basen-i-trondheim.jpg"
                        alt="Jan Tore, Emil og Bjørn Gunnar står ved helikopteret sammen med luftambulanse lege på basen i Trondheim."
                        color="primary"
                        buttonText="<b>Bli støttemedlem</b> - Din støtte bidrar til å redde liv"
                        link="/bidrag_sm/?kamp=03_aa24_ph_sm&mtm_campaign=aa24&mtm_kwd=sm&mtm_source=pasienthistorie&mtm_content=ph&mtm_cid=01"
                    />
                </Content>

                <Content width="medium">
                    <FactsList
                        title="Videoløsning: Legevaktens nye øyne"
                        borderColor="secondary"
                        bgColor="all-white"
                    >
                        <FactsItem>
                            På oppdrag fra Helse- og omsorgsdepartementet startet Stiftelsen Norsk
                            Luftambulanse utvikling og uttesting av videosamtaler ved et utvalg 113-
                            og legevaktsentraler i Norge i 2020.
                        </FactsItem>
                        <FactsItem>
                            Løsningen gir operatører ved legevakt og 113-sentraler mulighet til å
                            motta video direkte fra mobilkameraet til innringeren.
                        </FactsItem>
                        <FactsItem>
                            Video hjelper operatørene på 113-sentralene og legevaktsentralene til å
                            vurdere skaden/sykdommen til pasienten.
                        </FactsItem>
                        <FactsItem>
                            Ved en ulykke kan det hjelpe dem å vurdere situasjonen på skadestedet, i
                            tillegg til å gjøre det enklere å veilede den som ringer med å hjelpe
                            til før nødetatene kommer frem.
                        </FactsItem>
                        <FactsItem>
                            Løsningen ble overdratt til det offentlige høsten 2021. Stiftelsen
                            videreutvikler den kontinuerlig, noe som er mulig på grunn av bidrag fra
                            støttemedlemmene.
                        </FactsItem>
                        <FactsItem>
                            I dag bruker de fleste 113- og legevaktsentraler i Norge video i
                            nødsamtaler.
                        </FactsItem>
                        <FactsItem>
                            I snitt gjennomføres 2000 videosamtaler per uke med stiftelsens
                            videoløsning.
                        </FactsItem>
                        <FactsItem>
                            Hjelp 113 Video fungerer slik: Innringer blir bedt om å samtykke til at
                            sentralen kan kontrollere videokameraet på mobilen. Deretter får
                            innringer en SMS som må godkjennes. Operatøren kan da se alt som
                            foregår.
                        </FactsItem>
                        <FactsItem>
                            Det er også mulig å koble til ressurspersoner via medtitt. De vil da
                            motta en SMS med lenke til videoen, og kan se den samme videoen som
                            operatøren. Dette betyr at operatøren kan koble opp en lege på
                            legevaktsentralen, luftambulanselege eller andre for beslutningsstøtte.
                        </FactsItem>
                    </FactsList>
                </Content>

                <Content width="medium">
                    <div className="form-wrapper supportus-form-wrapper">
                        <Content width="small">
                            <SupportUsForm
                                id="support-us-999"
                                level={2}
                                renderCb={renderFromDone}
                                options={[
                                    {
                                        value: 250,
                                        label: '250'
                                    },
                                    {
                                        value: 300,
                                        label: '300'
                                    },
                                    {
                                        value: 400,
                                        label: '400'
                                    },
                                    {
                                        value: 500,
                                        label: '500'
                                    }
                                ]}
                            />
                        </Content>
                    </div>
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="large">
                    <CTABlock
                        divider
                        color="secondary"
                        title="Det koster <b>ingenting</b> å være bedre forberedt"
                        innerTitle="Last ned Hjelp 113-appen"
                        bulletPoints={[
                            'Alle nødnumre på ett sted',
                            'Koordinatene der du befinner deg',
                            'Oversikt over hjertestartere i nærheten',
                            'Appen er helt gratis'
                        ]}
                        buttonText="Last ned Hjelp 113 her"
                        link="/hjelp/"
                        orientation="left"
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/Norsk-Luftambulanse_March-2020_Kyle-Meyr_HR0046-1-e1707218019954.jpg"
                        alt="Luftambulansepersonell tar hånd om pasient."
                    />
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="small"></Content>
            </Section>
        </div>
    );
};

export default FoertiMinutterHLR;
